import React from "react";

const NoRouteFound = () => {
  return (
    <div>
      <h1>No route found, a 404 page</h1>
    </div>
  );
};

export default NoRouteFound;
